t = require('views/internal/teacup-with-helpers')('card_detail_vote_btn_sidebar')

module.exports = t.renderable ({ canVote, voted }) ->
  if canVote
    classes =
      'button-link': true
      'is-on': voted
      'js-unvote': voted
      'js-vote': !voted
    t.a { class: t.classify(classes) }, ->
      t.icon 'vote', 'vote'
      t.span '.on', ->
        t.icon 'check', { class: 'light' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_vote_btn_sidebar.coffee